
<template>
  <v-layout row justify-center>
    <v-dialog
      class="mobileFullscreen"
      v-model="showModal"
      lazy
      max-width="800px"
      :transition="utils.getSettings('animation')"
    >
      <v-card class="compact">
         <v-card-title
          class="headline blue darken-3 white--text"
          
          primary-title
        >
          Nieuwe prijsgroep
        </v-card-title>
        <v-card-text>
        <v-flex xs8>
          <v-text-field label="Omschrijving" v-model="newPrice.groupDescription"></v-text-field>
        </v-flex>
        </v-card-text>
         <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" flat @click.native="showModal = false">Sluiten</v-btn>
          <v-btn
            color="primary"
            @click="savePriceGroup()"
          >
            Opslaan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import * as utils from "@/utils/utils";
export default {
  name: "NewPriceGroup",
  data() {
    return {
      utils: utils,
      showModal: false,
      newPrice: {
        groupDescription: '',
        priceDescription: '',
        timeUnit: 1,
        price: 1,
        kmFree: 0,
        hours: 1
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    savePriceGroup() {
      const self = this;
      this.utils.setData(basePath + "api/prices/newPriceGroup/", this.newPrice)
        .then(function(response) {
          self.showModal = false;
          self.$emit("update",{priceCat: response.id});
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>


// WEBPACK FOOTER //
// src/components/Prices/NewPriceGroup.vue